import axios from "axios";
import { BackendURL } from "../globals";
import { Grid, Button } from "@material-ui/core";
import { Update } from "@material-ui/icons";
import { Alert } from "@material-ui/lab";
import React, { useState, useEffect, useMemo } from "react";
import RoutingList from "../components/RoutingList";
import RoutingBulkUpdateDialog from "../components/RoutingBulkUpdateDialog";
import API from "../api";
import { useResource } from "../useResource";
import { Project, Environment } from "../_generated";
import analytics from "../analytics";

export default function RoutingPage({ project }: { project: Project }) {
  const projectName = project.name;
  const [services] = useResource(API.services.list, projectName);
  const [environments] = useResource(API.environments.list, projectName);
  const [routes] = useResource(API.routes.list, projectName);
  const [showBulkUpdateDialog, setShowBulkUpdateDialog] = useState(false);

  const serviceNames = useMemo(() => {
    const serviceNames = new Map<number, any>();
    for (const service of services) {
      if (service.pk) serviceNames.set(service.pk, service.name);
    }
    return serviceNames;
  }, [services]);

  useEffect(() => {
    analytics.page("RoutingPage");
  }, []);

  function updateRoutesForProject(environments: Environment[]) {
    environments.forEach((environment) => {
      axios.post(
        `${BackendURL}/api/projects/${projectName}/environments/${environment.pk}/routes/update/`
      );
    });
    analytics.track("Route Update Confirmed");
  }

  return (
    <div>
      <RoutingBulkUpdateDialog
        open={showBulkUpdateDialog}
        environments={environments}
        onCancel={() => setShowBulkUpdateDialog(false)}
        onConfirm={(environments) => {
          updateRoutesForProject(environments);
          setShowBulkUpdateDialog(false);
        }}
      />

      <Grid>
        <Grid item xs={12}>
          <Alert severity="info">
            Routing is useful when you have multiple services and you wish to
            expose them behind a single endpoint. <br />
            It is also useful when you have multiple internal services and you
            want to have an authentication layer infront
            <br />
            By default we use AWS API Gateway for routing. Routing prefix must
            end with a '/'
            <br />
            Routing prefix below will match any route that starts with that. For
            example if your gateway domain is api.company.com and
            <br />
            routing prefix is /public/ then it will match
            api.company.com/public/x and api.company.com/public/y
            <br />
            <strong>
              After you modifying this section an infrastructure update is
              required for each environment
            </strong>
          </Alert>
        </Grid>
      </Grid>

      <RoutingList
        project={project}
        routes={routes}
        serviceNames={serviceNames}
        onVariableCreate={async (route) =>
          await API.routes.create(projectName, route)
        }
        onVariableUpdate={async (route) =>
          await API.routes.update(String(route.pk), projectName, route)
        }
        onVariableDelete={async (routeId) =>
          await API.routes.delete(String(routeId), projectName)
        }
      />

      <Grid container spacing={2} justify="flex-end">
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            startIcon={<Update />}
            onClick={() => {
              setShowBulkUpdateDialog(true);
            }}
          >
            Update
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}
